// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { fileSearch16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-file-search': IconFileSearch;
    }
}

/**
 * The icon component for the 'fileSearch' icon
 */
export class IconFileSearch extends Icon {
    public constructor() {
        super(fileSearch16X16);
    }
}

registerIcon('icon-file-search', IconFileSearch);
export const iconFileSearchTag = 'nimble-icon-file-search';
